import { fetchFromBackend } from '../../common/backend-client'

export async function queryTransfer(transferId) {
  return fetchFromBackend(`infrastructure/get_transfer?transfer_id=${transferId}`)
}

export async function queryOrderForTransferDetails(transferId) {
  return await fetchFromBackend(
    `ordering/queries/order-for-transfer-details/${transferId}`
  )
}

export async function queryTransferMetaInfo() {
  return fetchFromBackend('ordering/queries/transfer-meta-info')
}

export async function queryFiltersForTransfer(transferId) {
  return fetchFromBackend(`infrastructure/queries/get-filters?transfer_id=${transferId}`)
}
